import { apiFetch, type OpcionesLlamada } from "./apiClient";

export const adminApi = {
  listarAdministradores: () =>
    apiFetch<any>("/admin/usuarios"),

  crearAdministrador: (data: any, opciones: OpcionesLlamada = {}) =>
    apiFetch<any>("/admin/usuarios", {
      method: "POST",
      body: JSON.stringify(data),
      alFallar: opciones.alFallar,
    }),

  actualizarAdministrador: (id: number, data: any, opciones: OpcionesLlamada = {}) =>
    apiFetch<any>(`/admin/usuarios/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
      alFallar: opciones.alFallar,
    }),

  eliminarAdministrador: (id: number) =>
    apiFetch<any>(`/admin/usuarios/${id}`, {
      method: "DELETE",
    }),

  // Round 2026-04-30 septies — listarApiKeys/rotarApiKey removidos.
  // En producción las claves se configuran en Railway → Variables.

  // Nota: `dbQuery` (diagnóstico SQL admin) NO vive acá — la pestaña
  // `DbQueryTab.tsx` usa fetch crudo para poder distinguir los 3
  // outcomes del backend (200 / 403 password / 503 feature-off) sin
  // que apiFetch los oculte tras toasts genéricos. Endpoint:
  // POST /api/admin/db-query. Doc: docs/diagnostico-sql.md.
};
